import productSubtotalCalculator from './product-subtotal-calculator'
import { initializeOptions } from '@/catalog/product-options'
import { initializeCtaButtons } from '@/catalog/product-cta-buttons'
import { initializePrintMethods } from '@/catalog/product-print-methods'

export const initializeProduct = () => {
  // Override defaults and set up initial state from the URL.
  // Even if there's no hash set, this sets up the initial quantity before it's used below.
  initializeOptions()

  // Modules that depend on options to be initialized first
  initializeCtaButtons()
  initializePrintMethods()

  // Now that we've set everything in the DOM, we're ready to load the Marionette app,
  // which will read these values into a model.
  productSubtotalCalculator.start()
}
